



































import { eventBus } from "@/lib/event-bus";
import { directive as onClickaway } from "vue-clickaway";
import { Component, Vue } from "vue-property-decorator";

/**
 * Modal displayed as a confirmation to a request to reset the application.
 */
@Component({
  directives: {
    onClickaway
  }
})
export default class ModalReset extends Vue {
  /**
   * currenSelection represents the modal button selected.
   */
  private currentSelection: number = -1;

  /**
   * close closes the modal by emitting a close event.
   */
  private close(): void {
    eventBus.$emit("modal:close");
  }

  /**
   * handleSelection handles the selection of a modal button.
   */
  private handleSelection(n: number): void {
    this.currentSelection = n;
    setTimeout(() => {
      if (n === 0) {
        this.reset();
      } else if (n === 1) {
        this.close();
      }
    }, 200);
  }

  /**
   * reset closes the modal window and resets the survey experience.
   */
  private reset(): void {
    this.close();
    this.$router.push("/");
  }
}
